import { render, staticRenderFns } from "./CourseCardsAdvancedGrid.vue?vue&type=template&id=83871b52&"
import script from "./CourseCardsAdvancedGrid.vue?vue&type=script&lang=js&"
export * from "./CourseCardsAdvancedGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsCourseCard: require('/opt/build/repo/components/Cards/CourseCard.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
